'use strict';

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://www.jsonrpc.org/specification#error_object
var PARSE_ERROR = (0, _freeze2.default)({ message: 'Parse error', code: -32700 });
var INVALID_REQUEST = (0, _freeze2.default)({ message: 'Invalid request', code: -32600 });
var METHOD_NOT_FOUND = (0, _freeze2.default)({ message: 'Method not found', code: -32601 });
var INVALID_PARAMS = (0, _freeze2.default)({ message: 'Invalid params', code: -32602 });
var INTERNAL_ERROR = (0, _freeze2.default)({ message: 'Internal error', code: -32603 });

module.exports = (0, _freeze2.default)({
  PARSE_ERROR: PARSE_ERROR,
  INVALID_REQUEST: INVALID_REQUEST,
  METHOD_NOT_FOUND: METHOD_NOT_FOUND,
  INVALID_PARAMS: INVALID_PARAMS,
  INTERNAL_ERROR: INTERNAL_ERROR
});


// WEBPACK FOOTER //
// ./node_modules/jsonrpc-dispatch/lib/src/errors.js